import { Injectable } from '@angular/core';
import { URLSearchParams, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { AgencyLookupSummary } from '../../models/agency-lookup-summary';
import { AgencyLookupDetail } from '../../models/agency-lookup-detail';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../utils/response-util.service';
import { AppAuthHttpService } from '../../../http/app.auth.http.service';


@Injectable()
export class AgencyLookupHttpService {

  private agencySearchURL = `${this.environment.baseUrl}/api/lookup/agencies`;
  private agencyDetailsURL = `${this.environment.baseUrl}/api/lookup/agencies/details`;
  private subscriberAgencyURL = `${this.environment.baseUrl}/api/lookup/agencies/subscriber`;

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  search(searchText: string): Observable<List<AgencyLookupSummary>> {
    let params = new URLSearchParams();
    params.set('query', searchText);

    return this.http.get(this.agencySearchURL, { search: params })
      .map((res: Response) => res.json().map(object => new AgencyLookupSummary(object)))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getDetail(summaryRecord: AgencyLookupSummary): Observable<AgencyLookupDetail> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers }); // Create a request option

    return this.http.post(`${this.agencyDetailsURL}`, JSON.stringify(summaryRecord), options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  isSubscriberAgency(arcIata: string): Observable<boolean | Response> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers }); // Create a request option

    return this.http.get(`${this.subscriberAgencyURL}/${arcIata}`, options)
      .map(res => Boolean(res.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/lookup/agency-lookup/agency-lookup.http.service.ts